// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permission-groups {
  display: grid;
  gap: 1rem;
}

.permission-group {
  border: 1px solid #e8edf3;
  border-radius: 8px;
  overflow: hidden;
}

.permission-group__header {
  align-items: center;
  background: #f8fafc;
  border: 0;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem 1.125rem;
  text-align: left;
  width: 100%;
}

.permission-group--open .permission-group__header {
  border-bottom: 1px solid #e8edf3;
}

.permission-group__header:hover {
  background: #f3f7fb;
}

.permission-group__header:focus-visible {
  outline: 3px solid rgba(32, 139, 191, 0.25);
  outline-offset: -3px;
}

.permission-group__meta {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 0.65rem;
}

.permission-group__eyebrow {
  color: #8aa0b4;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.permission-group__title {
  color: #182230;
  font-size: 1rem;
  font-weight: 700;
  margin: 0.1rem 0 0;
}

.permission-group__description {
  color: #667085;
  font-size: 0.82rem;
  margin: 0.25rem 0 0;
}

.permission-group__count {
  background: #eaf6fb;
  border-radius: 999px;
  color: #155e75;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.35rem 0.7rem;
}

.permission-group__chevron {
  align-items: center;
  border: 1px solid #d8e2eb;
  border-radius: 999px;
  color: #667085;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 800;
  height: 24px;
  justify-content: center;
  line-height: 1;
  transition: transform 0.18s ease;
  width: 24px;
}

.permission-group--open .permission-group__chevron {
  transform: rotate(180deg);
}

.permission-table {
  margin-bottom: 0;
}

.permission-table tbody tr:last-child td {
  border-bottom: 0;
}

.permission-capabilities {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem 0.75rem;
}

.permission-capability {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 6px;
  display: inline-flex;
  gap: 0.4rem;
  margin: 0;
  min-height: 34px;
  padding: 0.35rem 0.65rem;
}

/* Reset Bootstrap's default float/negative-margin layout so the checkbox and
   label never overlap inside the pill, regardless of surrounding flex context. */
.permission-capability.form-check {
  padding-left: 0.65rem;
}

.permission-capability .form-check-input {
  flex-shrink: 0;
  float: none;
  margin: 0;
  position: static;
}

.permission-capability .form-check-label {
  margin: 0;
  white-space: nowrap;
}

@media (max-width: 767.98px) {
  .permission-group__header {
    align-items: flex-start;
    flex-direction: column;
  }

  .permission-group__meta {
    align-self: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SetPermission/SetPermission.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;iFACiF;AACjF;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".permission-groups {\n  display: grid;\n  gap: 1rem;\n}\n\n.permission-group {\n  border: 1px solid #e8edf3;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.permission-group__header {\n  align-items: center;\n  background: #f8fafc;\n  border: 0;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  padding: 1rem 1.125rem;\n  text-align: left;\n  width: 100%;\n}\n\n.permission-group--open .permission-group__header {\n  border-bottom: 1px solid #e8edf3;\n}\n\n.permission-group__header:hover {\n  background: #f3f7fb;\n}\n\n.permission-group__header:focus-visible {\n  outline: 3px solid rgba(32, 139, 191, 0.25);\n  outline-offset: -3px;\n}\n\n.permission-group__meta {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 0.65rem;\n}\n\n.permission-group__eyebrow {\n  color: #8aa0b4;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.permission-group__title {\n  color: #182230;\n  font-size: 1rem;\n  font-weight: 700;\n  margin: 0.1rem 0 0;\n}\n\n.permission-group__description {\n  color: #667085;\n  font-size: 0.82rem;\n  margin: 0.25rem 0 0;\n}\n\n.permission-group__count {\n  background: #eaf6fb;\n  border-radius: 999px;\n  color: #155e75;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.35rem 0.7rem;\n}\n\n.permission-group__chevron {\n  align-items: center;\n  border: 1px solid #d8e2eb;\n  border-radius: 999px;\n  color: #667085;\n  display: inline-flex;\n  font-size: 0.72rem;\n  font-weight: 800;\n  height: 24px;\n  justify-content: center;\n  line-height: 1;\n  transition: transform 0.18s ease;\n  width: 24px;\n}\n\n.permission-group--open .permission-group__chevron {\n  transform: rotate(180deg);\n}\n\n.permission-table {\n  margin-bottom: 0;\n}\n\n.permission-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.permission-capabilities {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem 0.75rem;\n}\n\n.permission-capability {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #e8edf3;\n  border-radius: 6px;\n  display: inline-flex;\n  gap: 0.4rem;\n  margin: 0;\n  min-height: 34px;\n  padding: 0.35rem 0.65rem;\n}\n\n/* Reset Bootstrap's default float/negative-margin layout so the checkbox and\n   label never overlap inside the pill, regardless of surrounding flex context. */\n.permission-capability.form-check {\n  padding-left: 0.65rem;\n}\n\n.permission-capability .form-check-input {\n  flex-shrink: 0;\n  float: none;\n  margin: 0;\n  position: static;\n}\n\n.permission-capability .form-check-label {\n  margin: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 767.98px) {\n  .permission-group__header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .permission-group__meta {\n    align-self: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
